import { SupabaseFloatingOutboxRecipientService } from "../../../../modules/stats/server/analytics-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";

import type { FloatingOutboxRecipient } from "../../../../modules/stats/server/analytics-service";
import type { UseSupabaseLoaderState } from "../../../../server/supabase/hooks/types";
import type { AnalyticsMoment } from "../types";

export const useFloatingOutboxRecipients = (
  moment: Pick<AnalyticsMoment, "id">,
): UseSupabaseLoaderState<FloatingOutboxRecipient[]> => {
  const { id } = moment;

  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const resp = await new SupabaseFloatingOutboxRecipientService(supabase).getAll(account_id, {
        filter: [{ key: "source_id", operator: "eq", value: id }],
        order: [{ column: "created_at", dir: "desc" }],
      });

      if (resp.error) {
        throw new Error("Unable to load floating outbox recipients");
      }

      return resp.data;
    },
    [id],
    "ce_admin",
  );
};
